import { ButtonHTMLAttributes, FC } from 'react';
import { ReactComponent as PlusIcon } from '../../../assets/icons/Plus.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/TrashBin2.svg';
import { ReactComponent as DownloadIcon } from '../../../assets/icons/download.svg';
import { ReactComponent as RefreshIcon } from '../../../assets/icons/Refresh.svg';
import './Button.scss';
import Loader from '../Loader';

interface ButtonProps {
  text?: string;
  onClick?: () => void;
  type?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
  isLoading?: boolean;
  isSecondary?: boolean;
  isTall?: boolean;
  isDisabled?: boolean;
  backgroundColor?: string;
  color?: string;
  variant?: 'delete' | 'secondary' | 'primary' | 'export' | 'download' | 'refresh';
  width?: string;
  height?: string;
  borderRadius?: string;
  opacity?: number;
  gap?: string;
  paddingTop?: string;
  paddingRight?: string;
  paddingBottom?: string;
  paddingLeft?: string;
  className?: string;
}

const Button: FC<ButtonProps> = ({
  text,
  type,
  isLoading,
  isSecondary,
  onClick,
  isTall,
  isDisabled,
  backgroundColor,
  color,
  variant,
  width,
  height,
  borderRadius,
  opacity,
  gap,
  paddingTop,
  paddingRight,
  paddingBottom,
  paddingLeft,
  className
}) => {
  return (
    <>
      
{isSecondary ? variant === "export" ? (<button
        type='button'
        className={`secondary-button ''}`}
        onClick={onClick}
        style={{
          background: 'rgba(226, 208, 208, 1)',
          color:'red',
          width,
          height,
          borderRadius:'20px',
          opacity,
          gap,
          paddingTop,
          paddingRight,
          paddingBottom,
          paddingLeft,
          fontWeight:'bold',
          fontSize:'18px'
        }}
        disabled={isDisabled}
      >
        {isLoading ? <Loader color='white' /> : text}
      </button>
      ) :(
        <button
          type='button'
          className={`secondary-button ${isDisabled ? 'disabled' : ''}`}
          onClick={onClick}
          disabled={isDisabled}
          style={{
            background: backgroundColor,
            color,
            width,
            height,
            borderRadius,
            opacity,
            gap,
            paddingTop,
            paddingRight,
            paddingBottom,
            paddingLeft,
          }}
        >
          {isLoading ? (
            <Loader color="white" />
          ) : variant === 'download' ? (
            <DownloadIcon className="button-icon" aria-hidden />
          ) : variant === 'refresh' ? (
            <RefreshIcon className="button-icon" aria-hidden />
          ) : (
            <PlusIcon />
          )}
          {isLoading ? null : text}
        </button>
      ) : variant === 'delete' ? (
        <button
          type='button'
          className={`delete-button button ${isDisabled ? 'disabled' : ''}`}
          onClick={onClick}
          disabled={isDisabled}
          style={{
            background: backgroundColor,
            color,
            width,
            height,
            borderRadius,
            opacity,
            gap,
            paddingTop,
            paddingRight,
            paddingBottom,
            paddingLeft,
          }}
        >
          <DeleteIcon />
          {text}
        </button>
      ) : (
        <button
          type={type ?? 'button'}
          className={`button ${isDisabled ? 'disabled' : ''} ${className ?? ''}`}
          onClick={onClick}
          style={{
            height: height || (isTall ? '48px' : ''),
            background: backgroundColor,
            color,
            width,
            borderRadius,
            opacity,
            gap,
            paddingTop,
            paddingRight,
            paddingBottom,
            paddingLeft,
          }}
          disabled={isDisabled}
        >
          {isLoading ? <Loader color='white' /> : text}
        </button>
      )}
    </>
  );
};

export default Button;
